<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title title">
      <i class="far fa-check-circle"></i> {{ "TITLE.TERMS-AND-CONDITIONS" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="margin-fixed">
      <re-captcha (resolved)="resolved($event)" (error)="onError($event)" errorMode="handled"></re-captcha>
    </div>
    <div class="tacbox">
      <input id="checkbox" type="checkbox" (change)="checked($event)"/>
      <label> {{"LABEL.I-AGREE-TO-THESE" | translate}} <a
        href="javascript:" (click)="openModalPdfViewer4termAndConditions()"> {{"LABEL.TERMS-AND-CONDITIONS"| translate}}</a>.</label>
    </div>
    <div class="tacbox">
      <input id="checkbox1" type="checkbox" (change)="checked($event)"/>
      <label> {{"LABEL.I-AGREE-TO-THESE" | translate}} <a
        href="javascript:" (click)="openModalPdfViewer4CertificateRequest()"> {{"LABEL.REQUEST-CERTIFICATE"| translate}}</a>.</label>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-danger" (click)="cancel()"><i
      class="fa fa-times"></i> {{"BUTTON.CANCEL" | translate}}</button>
    <button class="btn btn-success" (click)="accept()"><i class="fa fa-bookmark"></i> {{"BUTTON.ACCEPT" | translate}}
    </button>
  </div>
</div>
